import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import Program from './Program';
import { getProgramInfoInitiate } from '../../actions/programs';

const mapStateToProps = state => {
    const programInfo = _get(state, 'programs.programInfo', {});
    const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});

    return {
        programInfo,
        selectedWorkspace,
        fetchingProgramInfo:
            _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', true) &&
            !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', false),
        fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', true),
    };
};

const mapDispatchToProps = dispatch => ({
    getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Program);
